import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import clsx from 'clsx';
import {usePageData} from '../../../providers/PageDataProvider';
import Notifications from './Notifications';
import {useI18n} from '../../../providers/I18nProvider';
import {ReactComponent as BurgerIcon} from '../../../../../assets/images/layout/burger.svg';
import {ReactComponent as BackIcon} from '../../../../../assets/images/layout/left-arrow.svg';
import {useLayout} from '../LayoutProvider';
import {LogoutProps} from '../Types';
import {useNavbarActionComponent} from '../../../providers/NavActionProvider';

const Header: FC<LogoutProps> = ({setShowLogoutModal}) => {
	const {pageTitle} = usePageData();
	const {i18n, isJapanese} = useI18n();
	const navigate = useNavigate();

	const {
		shouldShowSidebarToggleButton,
		toggleSidebar,
		shouldShowBackButtonInNavbar,
		navBackButtonAction,
		shouldShowNavbarAction,
		hasNoficiationInNavbar,
	} = useLayout();

	const {navbarNodeAction} = useNavbarActionComponent();

	return (
		<div className='flex justify-between items-center py-6 px-4'>
			{shouldShowSidebarToggleButton && (
				<button className='pr-2.5 mr-2.5 border-r border-black-90' onClick={toggleSidebar}>
					<BurgerIcon />
				</button>
			)}
			{shouldShowBackButtonInNavbar && (
				<button
					className='absolute'
					onClick={() => {
						if (navBackButtonAction) {
							navBackButtonAction();
						} else {
							navigate(-1);
						}
					}}
				>
					<BackIcon />
				</button>
			)}
			<div
				className={clsx('text-lg sm:text-base lg:text-lg font-bold sm:font-medium w-full text-black-10', {
					'text-center': shouldShowBackButtonInNavbar,
				})}
			>
				{pageTitle}
			</div>
			<div className='sm:flex sm:items-center mr-[23px]'>
				<button
					className={clsx('text-sm sm:text-xs lg:text-sm font-medium text-muted hidden sm:block', {
						'w-[100px]': isJapanese,
						'mr-4.5 text-center': hasNoficiationInNavbar,
						'text-right': !hasNoficiationInNavbar,
					})}
					onClick={() => setShowLogoutModal(true)}
				>
					{i18n('LAYOUT.HEADER.BUTTON.LOGOUT')}
				</button>
				{hasNoficiationInNavbar && (
					<div className='mr-2 sm:mr-0'>
						<Notifications />
					</div>
				)}
			</div>
			{shouldShowNavbarAction && <div>{navbarNodeAction}</div>}
		</div>
	);
};

export {Header};
